<div
  class="app-direction-fix"
  [dir]="direction">
  <ui-platform-notification></ui-platform-notification>
  <sh-main-nav-guard
    [hideHeader]="hideHeader"
    [hideSearch]="hideHeaderSearch"
    [isScrolled]="isScrolled"></sh-main-nav-guard>
  <nav
    class="onboarding-header"
    *ngIf="showOnboardingHeader && hideHeader">
    <!-- TODO - if there are more campaigns rework to more generic solution -->
    @if (isSLSP) {
      <a
        class="main-nav-platform-desktop-logo"
        [href]="slspLogoUrl">
        <img
          src="/assets/images/logo/logo-smarthead-business-turquoise.svg"
          title="SmartHead" />
      </a>
      <span class="cooperation">{{ 'general.in-cooperation-with' | transloco }}</span>
      <img
        class="slsp-logo"
        src="/assets/images/onboarding/logo-slsp.svg"
        alt="SLSP logo" />
    } @else if (isCSAS) {
      <a
        class="main-nav-platform-desktop-logo"
        [href]="csasLogoUrl">
        <img
          src="/assets/images/logo/logo-smarthead-business-turquoise.svg"
          title="SmartHead" />
      </a>
      <span class="cooperation">{{ 'general.in-cooperation-with' | transloco }}</span>
      <img
        class="slsp-logo"
        src="/assets/images/onboarding/logo-csas.webp"
        alt="CSAS logo" />
    } @else {
      <a
        class="main-nav-platform-desktop-logo"
        [routerLink]="items.newsfeedItem.link">
        <img
          src="/assets/images/logo/logo-smarthead-business-turquoise.svg"
          title="SmartHead" />
      </a>
    }
    <div class="splitter"></div>
    <sh-main-nav-languages></sh-main-nav-languages>
  </nav>

  <div class="sh-main-container">
    <router-outlet></router-outlet>
  </div>

  <sh-footer></sh-footer>

  <sh-cookies-settings></sh-cookies-settings>
</div>
